import { CheckoutScreen } from '../features/checkout/CheckoutScreen'

export function CheckoutPage() {
  return <CheckoutScreen />
}
